<template>
  <b-nav-text class="waves-effect waves-light">
    <hamber-button />
  </b-nav-text>
</template>

<script>
import HamberButton from "@/components/HamberButton/HamberButton";
export default {
  name: "RightNavItems",
  components: {
    HamberButton
  }
};
</script>
